// #1090: yalnız adres verisi. App.tsx rota listesini kurmak için bunu okur; sayfa kodunu (landing, gizlilik) çekmemesi
// için `public-aliases.tsx`ten ayrıldı. Sayfalar `AliasPage` ile tembel yüklenir.
import { BRAND } from '@/config/brand.generated'

// #918: harici doğrulama için ek herkese açık adresler. İçerik asıl sayfalarla aynıdır; fark yalnız doğrulama kopyası
// kurallarıdır (bkz. components/layout/public-variant.tsx). Sunucu bu adresleri hazır HTML ile verir (nginx + prerender),
// uygulama da aynı adresleri aynı içerikle çizer: betik yüklenince sayfa değişmez, 404'e/girişe düşmez.
// Her "aile" bir ana sayfa + bir gizlilik adresidir; konsola bir aile kaydedilir, içerik ailelerde aynıdır, yalnız canonical
// ve gizlilik bağlantısı ailenin KENDİ adresini gösterir (denetçi bağlantıyı konsoldaki adresle birebir eşler).
export interface AliasFamily {
  home: string
  privacy: string
}

export const ALIAS_FAMILIES: readonly AliasFamily[] = [
  { home: '/home.html', privacy: '/privacy-policy.html' },
  { home: '/welcome.html', privacy: '/privacy-notice.html' },
]

export const aliasUrl = (page: string): string => `https://${BRAND.primaryDomain}${page}`

const bare = (page: string): string => page.replace(/\.html$/, '')

export interface AliasRoute {
  path: string
  kind: 'home' | 'privacy'
  family: AliasFamily
}

// Uygulamadaki rota biçimleri: uzantılı ve uzantısız (sondaki eğik çizgiyi yönlendirici zaten yok sayar).
export const ALIAS_ROUTES: readonly AliasRoute[] = ALIAS_FAMILIES.flatMap((family) => [
  { path: bare(family.home), kind: 'home' as const, family },
  { path: family.home, kind: 'home' as const, family },
  { path: bare(family.privacy), kind: 'privacy' as const, family },
  { path: family.privacy, kind: 'privacy' as const, family },
])
